// mian list for pool

export default [
    {
        id: "LAVA-USDT",
        token_symbol: "LAVA-USDT",
        num_id: 0,
        item_icon: "lava.png",
        item_icon_b: "usdt.png",
        token_address: "0x3f15f2075aa11be4757aa522d133c0dbc7e878ce",
        //token_decimals: 18,
        token_earn_symbol: "LAVA",
        // 合约地址
        reward_address: "0x8085086439699958a6E98aaafa45B4e488916B5C",
        apy: "-",
        start_time: {
          en: "2022/01/05:22:00",
          zh: "2022/01/05:22:00"
        },
        des_earn_per_day: "",
        price_on_usd: 1,
        multiple: 0,
        daily_supply: 126000,
      },
];